import { useParams } from 'react-router-dom';

import LimitPieFactory from '@components/limitPieFactory/LimitPieFactory';
import useGetLimits from '@hooks/queries/useGetLimits';

const InstallmentCreditLimitPieContainer = () => {
    const { accountId } = useParams();

    const { data: limits, isLoading: limitsLoading } = useGetLimits(+accountId);

    return (
        <LimitPieFactory
            isLoadingLimits={limitsLoading}
            limits={limits}
            type="InstallmentCreditLimit"
        />
    );
};

export default InstallmentCreditLimitPieContainer;
